class MyDeliverySaverPanelController {
    constructor($scope, deliverySaverConstants) {
        this.$scope = $scope;
        this.deliverySaverConstants = deliverySaverConstants;
    }

    $onInit() {
        this.isExpanded = false;
        this.$scope.$on(this.deliverySaverConstants.PANEL_EXPANDED_BROADCAST_EVENT, (event, id) => this.onSiblingPanelExpanded(id));
        this.$scope.$on(this.deliverySaverConstants.PANEL_EXPAND, (event, section) => this.onExpandBroadcast(section));
    }

    toggleExpanded() {
        this.isExpanded = !this.isExpanded;
        if (this.isExpanded) {
            this.$scope.$emit(this.deliverySaverConstants.PANEL_EXPANDED_EMIT_EVENT, this.$scope.$id);
        }
    }

    onExpandBroadcast(section) {
        if (this.section === section && !this.isExpanded) {
            this.isExpanded = true;
        }
    }

    /**
     * Collapse this panel when the parent scope tells me
     * one of my brother scopes has expanded
     * @param {number} scopeId The scope ID of the panel that expanded
     */
    onSiblingPanelExpanded(scopeId) {
        if (scopeId !== this.$scope.$id) {
            this.isExpanded = false;
        }
    }
}

MyDeliverySaverPanelController.$inject = ['$scope', 'DeliverySaverConstants'];

const MyDeliverySaverPanelComponentDefinition = {
    bindings: {
        heading: '<',
        isExpanded: '<',
        section: '<',
    },
    transclude: true,
    controller: MyDeliverySaverPanelController,
    template: require('./my-delivery-saver-panel.component.html').trim(),
};

module.exports = {
    MyDeliverySaverPanelController,
    MyDeliverySaverPanelComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/deliverysaver/mydeliverysaver/panel/my-delivery-saver-panel.component.js